import React from 'react';
import { IIconProps } from '../interfaces';

const InfoIcon = (props: IIconProps) => {
  return (
      <svg
          width={ props.width }
          height={ props.width }
          viewBox="0 0 17 17"
          className={ props.classes }
          xmlns="http://www.w3.org/2000/svg"><g transform="translate(1 1)" stroke={ props.color } fill="none" fillRule="evenodd"><circle strokeWidth="1.2" cx="7.252" cy="7.252" r="7.252"/><path d="M6.58 3.804c0-.27.164-.514.415-.617a.675.675 0 0 1 .732.144c.192.191.25.478.145.728a.672.672 0 0 1-1.292-.255zm1.343 5.78h-.168V6.08c0-.276-.225-.5-.503-.5H6.58a.503.503 0 0 0-.504.5c0 .277.226.5.504.5h.168v3.003H6.58a.503.503 0 0 0-.504.5c0 .277.226.501.504.501h1.344a.502.502 0 0 0 .504-.5c0-.276-.226-.5-.504-.5z" strokeWidth=".2" fill={ props.color } /></g></svg>
  )
};

export default InfoIcon;